import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=c87652e2&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"
import style0 from "./InformationDialog.vue?vue&type=style&index=0&id=c87652e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87652e2",
  null
  
)

export default component.exports